module.exports = __webpack_public_path__ + "static/media/logo.c45a5d86.png";